module.exports = __webpack_public_path__ + "static/media/Img_12.96c1e701.JPG";